const storage = {
    not_configured: 'Der Storage-Anbieter ist nicht konfiguriert.',
    missing_parameter: 'Fehlender Parameter {{parameter}} für den Storage-Anbieter.',
    upload_error: 'Das Hochladen der Datei zum Storage-Anbieter ist fehlgeschlagen.',
};
export default storage;
